export var EPaymentLayoutConstant = /*#__PURE__*/function (EPaymentLayoutConstant) {
  EPaymentLayoutConstant[EPaymentLayoutConstant["Height"] = 84] = "Height";
  EPaymentLayoutConstant[EPaymentLayoutConstant["Gap"] = 8] = "Gap";
  return EPaymentLayoutConstant;
}({});